import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnNF: CultureInfo = {
  name: 'en-NF',
  displayName: 'English (Norfolk Island)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-NF',
  parent: CultureInfoEn
};
